import logger from "../../../../utils/logger";
import { WsChangeBody } from "../../../../api/socket/WebSocketService";
import { P } from "ts-pattern";
import { UnitHashElement } from "../../../../context/map/units/unitsStore";
//@ts-ignore
import { Match } from "ts-pattern/dist/types/Match";
//@ts-ignore
import * as symbols from "ts-pattern/dist/internals/symbols";

const log = logger.getLogger("track.ws.handler")
export default function(unit: UnitHashElement) {
    return <T extends [any, any][]>(change: Match<WsChangeBody, typeof symbols.unset, T, void>) => {
        return change
            .with({ track: P.not(P.nullish) }, () => {
                // TODO! Пока нет времени плеера, ограничиваем след от движения последними 100 точками

            })
    }
}